import React from 'react';
import ListItem from '../DataTransferObjects/ListItem';
 
interface CheckBoxListProps { 
  groupName: string;
  data: ListItem[]; 
  changeState: (value: string) => void;
}
const CheckBoxList: React.FC<CheckBoxListProps> = (props) => {
  return (
    <div className="col"> 
      {props.data.map((item, index) => {
        const id = `chk_${props.groupName}_${index}`;

        return (
          <div className="input-check" key={item.value}>
            <input
              type="radio"
              value={item.value}
              name={props.groupName}
              id={id}
              onChange={(e) => props.changeState(e.target.value)}
              checked={item.checked}
            />
            <label htmlFor={id}>{item.text}</label>
          </div>
        );
      })}
    </div>
  );
};

export default CheckBoxList;
